/* global glide */
(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.fullWidthCtaSlider = {
    attach: function (context) {
      let options = {
        type: 'slider',
        perView: 1,
        gap: 0,
        bound: true,
        startAt: 0,
      };

      let carousels = context.querySelectorAll('.js-full-width-cta-slider.glide');
      Object.values(carousels).map(function (carousel) {

        let glide = new Glide(carousel, options);

        glide.mount();

        let rightArrow = carousel.querySelector('.glide__arrow--right');
        let leftArrow = carousel.querySelector('.glide__arrow--left');

        function goRight(e) {
          e.preventDefault();
          glide.go('>');
        }

        function goLeft(e) {
          e.preventDefault();
          glide.go('<');
        }

        rightArrow.addEventListener('click', goRight);
        leftArrow.addEventListener('click', goLeft);
      });
    }
  };
}(jQuery, Drupal));
